import ar from '@/internationalization/trans/chefs/ar/ar.json';
export default {
  trans: ar,
};
